import { Link } from "react-router-dom";


const TopHeroMarquee = ({ data }) => {
  return (
    <div className="w-full mt-2 mb-5 flex gap-4 animate-[marquee_5s_linear_infinite] sm:animate-[marquee_40s_linear_infinite] hover:[animation-play-state:paused]">
      {data.map((e) => (
        <div key={e._id} className="min-w-[340px] h-28 sm:h-36 bg-gradient-to-r from-[#6E4A7E] via-[#7F5C8F] to-[#8F6BA0] rounded-xl">
          <div className="p-2">
            <div className="flex gap-4 py-1 sm:py-4">
              <img src={e.planImage} className="rounded-full w-12 h-12" />
              <div>
                <h1 className="text-white text-sm font-bold text-[16px]">
                  {e.planName}
                </h1>

                <div className="flex gap-x-2 mt-1">
                  {e.exams?.slice(0, 4).map((exam) => (
                    <div key={exam._id || exam.examName} className="flex items-center gap-1 text-[12px] text-white">
                      <span className="w-2 h-2 rounded-full bg-[#fab787]" />
                      {exam.examName}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="text-white flex justify-between ml-2">
              <div className="flex gap-2">
                <h1 className="text-3xl font-bold">₹ {e.offerPrice}</h1>
                <h1 className="line-through mt-2 text-purple">₹{e.price}</h1>
              </div>

              <Link to={`/dash/checkout/${e._id}`}>
                <div className="w-32 py-2 mr-4 rounded-full bg-purple text-white text-center shadow-[4px_6px_#A695AE]">
                  Buy Course
                </div>
              </Link>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TopHeroMarquee;
